export default __webpack_public_path__ + "static/media/filter-icon.d1e75341.svg";